module.exports = __webpack_public_path__ + "img/schedule.d793c98d.svg";